import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-foreground-600 text-xs font-medium mb-4 whitespace-nowrap">
            Eksploruj
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950 mb-3">
            {t("categories.title")}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            {t("categories.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 group-hover:bg-white/20 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-white text-center transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 group-hover:text-white/70 text-center transition-colors">
                {cat.description}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}